module.exports = "/images/vendor/tinymce/skins/lightgray/loader.gif?394bafc3cc4dfb3a0ee48c1f54669539";